document.addEventListener("DOMContentLoaded", function() {

    // Left star hover
    document.querySelectorAll(".wrapper-feature-star-left img").forEach(img => {
    img.addEventListener("mouseenter", () => {
        gsap.to(img, {
        rotation: 45,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });

    img.addEventListener("mouseleave", () => {
        gsap.to(img, {
        rotation: 0,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });
    });

    // Right star hover
    document.querySelectorAll(".wrapper-feature-star-right img").forEach(img => {
    img.addEventListener("mouseenter", () => {
        gsap.to(img, {
        rotation: 45,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });

    img.addEventListener("mouseleave", () => {
        gsap.to(img, {
        rotation: 0,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });
    });


   var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 4000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    freeMode: true,
    freeModeMomentum: false,
    allowTouchMove: false,
    breakpoints: {
        1920: {
        slidesPerView: 5,
        spaceBetween: 20
        },
        1366: {
        slidesPerView: 4,
        spaceBetween: 20
        },
        1024: {
        slidesPerView: 3,
        spaceBetween: 20
        },
        768: {
        slidesPerView: 3,
        spaceBetween: 20
        },
        767: {
        slidesPerView: 0.8,
        spaceBetween: 20,
        allowTouchMove: false,
        autoplay: true
        }
    }
    });



    let tl = gsap.timeline();

    gsap.to("#svg-logo #letter-B" , {
        duration: 1.5,
        strokeDasharray: 1500,
        stagger: .15,
        transformOrigin: "center"
    });

    gsap.to("#svg-logo #letter-butree" , {
        duration: 3,
        strokeDasharray: 3000,
        stagger: .15,
        transformOrigin: "center"
    });
    tl.to("#svg-logo #letter-dy" , {
        duration: 1,
        strokeDasharray: 1500,
        stagger: .15,
        transformOrigin: "center"
    });
    gsap.to("#svg-logo #letter-o" , {
        duration: 1.5,
        strokeDasharray: 1500,
        stagger: .15,
        transformOrigin: "center"
    });

    gsap.to(" #svg-logo #letter-cean" , {
        duration: 3,
        strokeDasharray: 1000,
        stagger: .15,
        transformOrigin: "center"
    });
    tl.fromTo(
        "#svg-logo #brid-1, #svg-logo #brid-2",
        { fill: "transparent", },   // from color
        { fill: "#ffffff", duration: 1 } // to color
    );
    tl.to(
        "#svg-logo #letter-B, #svg-logo #letter-butree, #svg-logo #letter-dy, #svg-logo #letter-o, #svg-logo #letter-cean",
        {
            fill: "#ffffff",
            duration: 0.5 ,
            stroke: "#ffffff"
        }
    );

    var input = document.querySelector("#ContactForm-phone");
    window.intlTelInput(input, {
    initialCountry: "US",
    separateDialCode: true,
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.13/js/utils.min.js",
    // ye line bohot important hai ↓
    loadUtilsOnInit: true
    });
    document.querySelector('.iti__flag-container , .iti__flag').style.backgroundImage = "url('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.13/img/flags.png')";



});

// ============================================================
// Lifestyle image on color-swatch hover (product page + collection cards)
// ============================================================

function getLifestyleMap(wrapper) {
  var section = wrapper.closest('[data-section]');
  if (section) {
    var mapScript = document.getElementById('lifestyle-map-' + section.dataset.section);
    if (mapScript) {
      try { return JSON.parse(mapScript.textContent); } catch (e) {}
    }
  }
  var card = wrapper.closest('.card-wrapper');
  if (card && card.dataset.lifestyleMap) {
    try { return JSON.parse(card.dataset.lifestyleMap); } catch (e) {}
  }
  return null;
}

function getGalleryImgs(wrapper) {
  var section = wrapper.closest('[data-section]');
  if (section) {
    var gallery = section.querySelector('media-gallery');
    if (gallery) {
      var img = gallery.querySelector('.product__media-item.is-active img');
      return img ? [img] : [];
    }
  }
  var card = wrapper.closest('.card-wrapper');
  if (card) return Array.from(card.querySelectorAll('.card__media img'));
  return [];
}

function normalizeColorName(s) {
  return (s || '')
    .toLowerCase()
    .replace(/[\/\-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function findLifestyleUrl(lifestyleMap, colorName) {
  var normColor = normalizeColorName(colorName);
  for (var key in lifestyleMap) {
    if (key === '_') continue;
    if (normalizeColorName(key) === normColor) {
      return lifestyleMap[key];
    }
  }
  return null;
}

// ------------------------------------------------------------
// Portrait photos (lifestyle shots) still FILL the card edge to
// edge (object-fit stays "cover", same as Dawn's default — no
// blur, no letterboxing, no gaps). The only change: for a photo
// that's taller than it is wide, the crop anchors to the TOP of
// the image instead of the center, so heads/faces stay in frame
// and only the bottom gets trimmed. Landscape/square photos are
// left completely untouched.
//
// Applies to both:
//   1) The swapped-in lifestyle photo while a COLOR SWATCH is
//      hovered (mouseover/mouseout below).
//   2) Dawn's OWN native "second photo on card hover" — the
//      plain hover-anywhere-on-card crossfade, unrelated to
//      swatches (scanCardImagesForTopAnchor below).
// ------------------------------------------------------------
(function injectLifestyleFitStyles() {
  if (document.getElementById('lifestyle-fit-styles')) return;
  var style = document.createElement('style');
  style.id = 'lifestyle-fit-styles';
  style.textContent =
    '.lifestyle-fit-top { object-position: top !important; }' +
    '.lifestyle-fit-contain { object-fit: contain !important; }';
  document.head.appendChild(style);
})();

// ------------------------------------------------------------
// Manual per-product fine-tuning. The automatic "portrait →
// object-position: top" rule above is a good default, but a few
// specific photos need a hand-picked crop instead of plain top:
//   - storm: this hover photo is a lifestyle shot that's almost
//     square (not a tall portrait), and the cap sits right at the
//     very top edge of the original photo itself — there's no
//     extra pixels above it to reveal with object-position alone.
//     Fix: zoom IN a bit (scale > 1) and nudge the visible window
//     down (translateY) so the crop tightens around the head/cap
//     and crops more of the shirt/body instead — the photo still
//     fills the card edge to edge (no background gaps), but now
//     shows the cap with real headroom above it.
//   - saltwater-veteran: plain "top" cut too close to the crown;
//     backed off a bit so the cap sits fully in frame, centered.
//     This one's source photo IS a true tall portrait with real
//     headroom, so position-only was enough — no zoom needed.
// Keyed by product handle (from the card's own product link), so
// adding another override later is a one-line addition here.
// ------------------------------------------------------------
var cardImagePositionOverrides = {
  'storm': { position: '50% 50%', transform: 'scale(1.15) translateY(4%)' },
  'saltwater-veteran': { position: '50% 40%' }
};

function getProductHandle(card) {
  var link = card.querySelector('a[href*="/products/"]');
  if (!link) return null;
  var href = link.getAttribute('href') || '';
  var match = href.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : null;
}

function applyTopAnchorIfPortrait(img, override) {
  function decide() {
    if (override) {
      img.classList.remove('lifestyle-fit-top');
      img.style.objectPosition = override.position;
      img.style.transform = override.transform || '';
      return;
    }
    if (img.naturalWidth && img.naturalHeight && img.naturalHeight > img.naturalWidth) {
      img.classList.add('lifestyle-fit-top');
    } else {
      img.classList.remove('lifestyle-fit-top');
    }
  }
  if (override) {
    // Override values are hand-picked constants, not dependent on
    // image dimensions — apply immediately, no need to wait for load.
    decide();
  } else if (img.complete && img.naturalWidth) {
    decide();
  } else {
    img.addEventListener('load', decide, { once: true });
  }
}

document.addEventListener('mouseover', function (e) {
  var wrapper = e.target.closest('.se-swatch-wrapper');
  if (!wrapper || wrapper.dataset.lifestyleHover === 'true') return;
  wrapper.dataset.lifestyleHover = 'true';

  var lifestyleMap = getLifestyleMap(wrapper);
  if (!lifestyleMap) return;

  var labelEl = wrapper.querySelector('.se-hide');
  if (!labelEl) return;

  var colorName = labelEl.textContent.trim().toLowerCase();
  var lifestyleUrl = findLifestyleUrl(lifestyleMap, colorName);
  if (!lifestyleUrl) return;

  var imgs = getGalleryImgs(wrapper);
  imgs.forEach(function (img) {
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.src = lifestyleUrl;
    img.removeAttribute('srcset');
    applyTopAnchorIfPortrait(img);
  });
});

document.addEventListener('mouseout', function (e) {
  var wrapper = e.target.closest('.se-swatch-wrapper');
  if (!wrapper) return;
  if (wrapper.contains(e.relatedTarget)) return;

  wrapper.dataset.lifestyleHover = 'false';

  var imgs = getGalleryImgs(wrapper);
  imgs.forEach(function (img) {
    if (!img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
    delete img.dataset.originalSrc;
    delete img.dataset.originalSrcset;
    applyTopAnchorIfPortrait(img);
  });
});

// ============================================================
// Same top-anchored-crop fix, but ONLY for Dawn's native SECOND
// (hover-only) card photo — never the first/default photo, which
// stays exactly as before everywhere (mens-collection, sun-shirts,
// etc. all keep their normal center-cropped default images).
// This only matters for cards whose hover photo is a portrait
// lifestyle shot, like the hat-collection cases.
// ============================================================

function scanCardImagesForTopAnchor() {
  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    var container = card.querySelector('.card__media .media');
    if (!container) return;
    var imgs = container.querySelectorAll('img.motion-reduce');
    if (imgs.length < 2) return; // no secondary/hover image on this card — nothing to touch
    var handle = getProductHandle(card);
    var override = handle ? cardImagePositionOverrides[handle] : null;
    applyTopAnchorIfPortrait(imgs[1], override);
  });
}

document.addEventListener('DOMContentLoaded', scanCardImagesForTopAnchor);

var cardImageScanTimer = null;
var cardImageObserver = new MutationObserver(function () {
  clearTimeout(cardImageScanTimer);
  cardImageScanTimer = setTimeout(scanCardImagesForTopAnchor, 150);
});
cardImageObserver.observe(document.body, { childList: true, subtree: true });

// ============================================================
// MAIN/default card image (the always-visible first photo, not
// the hover one) — this is where mens-collection's graphic
// illustrations live. Those are artwork, not photos, so any
// cropping at all can cut off part of the design (text at the
// top and bottom, etc). When that main image isn't square, show
// it in full with object-fit: contain instead of letting Dawn's
// default "cover" crop it. Square images (most normal product
// photography) are left completely untouched.
// ============================================================

function applyContainIfNotSquare(img) {
  function decide() {
    if (!img.naturalWidth || !img.naturalHeight) return;
    var ratio = img.naturalWidth / img.naturalHeight;
    if (ratio < 0.92 || ratio > 1.08) {
      img.classList.add('lifestyle-fit-contain');
    } else {
      img.classList.remove('lifestyle-fit-contain');
    }
  }
  if (img.complete && img.naturalWidth) {
    decide();
  } else {
    img.addEventListener('load', decide, { once: true });
  }
}

function scanMainCardImages() {
  document.querySelectorAll('.card__media .media').forEach(function (container) {
    var imgs = container.querySelectorAll('img.motion-reduce');
    if (!imgs.length) return;
    applyContainIfNotSquare(imgs[0]); // first image = the default/main photo
  });
}

document.addEventListener('DOMContentLoaded', scanMainCardImages);

var mainImageScanTimer = null;
var mainImageObserver = new MutationObserver(function () {
  clearTimeout(mainImageScanTimer);
  mainImageScanTimer = setTimeout(scanMainCardImages, 150);
});
mainImageObserver.observe(document.body, { childList: true, subtree: true });

// ============================================================
// Force correct swatch to show as "selected" on hat-collection cards
// ============================================================

function applyCardSwatchSelection() {
  document.querySelectorAll('.card-wrapper[data-color-label]').forEach(function (card) {
    var targetColor = (card.dataset.colorLabel || '').trim().toLowerCase();
    if (!targetColor) return;

    var swatches = card.querySelectorAll('.se-swatch-wrapper');
    if (!swatches.length) return;

    var matched = null;
    swatches.forEach(function (wrapper) {
      var labelEl = wrapper.querySelector('.se-hide');
      var swatchColor = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
      var swatchEl = wrapper.querySelector('.se-type-swatch');
      if (!swatchEl || !swatchColor) return;

      if (swatchColor === targetColor) {
        matched = swatchEl;
      }
    });

    if (!matched) return;

    card.querySelectorAll('.se-type-swatch').forEach(function (el) {
      var isMatch = el === matched;
      el.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      el.classList.toggle('lifestyle-swatch-selected', isMatch);
    });
  });
}

var swatchSelectionTimer = null;
var hatSwatchObserver = new MutationObserver(function () {
  clearTimeout(swatchSelectionTimer);
  swatchSelectionTimer = setTimeout(applyCardSwatchSelection, 150);
});
hatSwatchObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', applyCardSwatchSelection);